
import { computed, defineComponent } from "vue";

export default defineComponent({
	props: {
		expanded: Boolean,
	},
	setup(props) {
		const isActive = computed(() => {
			return props.expanded;
		});

		return { isActive };
	},
});
